module.exports = "<app-scaffold>\n  <basic-page-header title=\"Contact Us\"></basic-page-header>\n\n  <div class=\"container basic-page\">\n    <div class=\"row--narrow\">\n      <basic-page-content content=\"ctrl.content\"></basic-page-content>\n    </div>\n  </div>\n</app-scaffold>"


//////////////////
// WEBPACK FOOTER
// ./src/partials/contact.html
// module id = 306
// module chunks = 0